import DatePick_MI from 'components/DatePicker_MI'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { checkPendingVIN, vinLookup } from 'services/Api'
import { storageData } from 'services/Services'
import "./BodyVIN.css"

const BodyVIN = ({ requestContext, vehicleContext, endorsementClassStr, endorsementSetClassStr }) => {
    const requestTypeContext = useContext(requestContext)
    const newVehicleContext = useContext(vehicleContext)
    const [vinResponse, setVinResponse] = useState("")
    const vinRef = useRef(null)

    const IsAddVehiclePending = JSON.parse(storageData.getItem('EndorsementStatuses')).IsAddVehiclePending;
    const IsReplaceVehiclePending = JSON.parse(storageData.getItem('EndorsementStatuses')).IsReplaceVehiclePending;
    const [vinList, setVinList] = useState([])

    useEffect(() => {
        const getList = async () => {
            if(IsAddVehiclePending || IsReplaceVehiclePending){
                const req = {
                    "policyNumber": requestTypeContext[endorsementClassStr]?.policyNumber,
                    "env": requestTypeContext[endorsementClassStr]?.env
                }

                const vinResponse = await checkPendingVIN(req);
                setVinList(vinResponse?.data?.vinList);
            }
        }
        getList();
    }, []);

    // Generates vehicle from vin
    const checkVin = async () => {
        requestTypeContext.setVinLoad(true)
        vinRef.current.value = vinRef.current.value?.toUpperCase();
        const enteredVIN = vinRef.current.value.trim();
        const checkVin = checkVinExists(enteredVIN);
        const checkRecentVIN = checkRecentAddition(enteredVIN);
        const checkForSpecialCharacters = checkSpecialCharacters(enteredVIN);
        const vinCharacterLimit = checkCharacterLimit(enteredVIN);

        // Pending changes
        if (checkRecentVIN) {
            setVinResponse("You have already submitted a request for this vehicle.");
            requestTypeContext.setVinLoad(false)
            return;
        }

        // Duplicate Vin
        if (checkVin) {
            setVinResponse("The vehicle related to the VIN you entered is already on your policy. If you have any questions, please live chat with us on cure.com or call 800-535-2873 to speak with a representative.")
            requestTypeContext.setVinLoad(false)
            return;
        }

        // Empty input
        if (vinRef.current.value == "") {
            setVinResponse("Please provide a VIN.")
            requestTypeContext.setVinLoad(false)
            return
        }

        // Special characters in vin
        if (checkForSpecialCharacters) {
            setVinResponse("Please do not include any special characters. Your VIN should only be letters and numbers.")
            requestTypeContext.setVinLoad(false)
            return
        }
        // Character limit must be under 25 characters
        if (vinCharacterLimit) {
            setVinResponse("The provided VIN exceeds 25 characters. If you have any questions, please live chat with us on cure.com or call 800-535-2873 to speak with a representative.")
            requestTypeContext.setVinLoad(false)
            return;
        }

        // Specific Vin
        const specificVin = ["1C6RR7KG7DS661851"].includes(enteredVIN);
        if (specificVin) {
            setVinResponse("We are unable to verify the VIN that you entered. Please try again. If you continue to run into the same error, please call 800-535-2873 to proceed with your request.")
            requestTypeContext.setVinLoad(false)
            return;
        }

        // Vin contains I, O or Q.
        const vinHasUnusedLetters = enteredVIN.toUpperCase().includes("I") || enteredVIN.toUpperCase().includes("O") || enteredVIN.toUpperCase().includes("Q");
        if (vinHasUnusedLetters) {
            setVinResponse("We are unable to verify this VIN.  Please confirm the VIN you entered or use the year, make and model of your vehicle to obtain a quote.  The letters I, O, and Q are not used in VIN numbers.  NOTE:  If your vehicle’s model year is prior to 1985, you must call to obtain a quote.")
            requestTypeContext.setVinLoad(false)
            return;
        }

        // Successful vin input
        var vinResponse = await vinLookup(enteredVIN);
        var grossWeight = vinResponse?.data?.GrossVehicleWeight !== null ? parseInt(vinResponse?.data?.GrossVehicleWeight) < 10000 : true

        if (!(vinResponse?.data?.error == null && vinResponse != undefined && vinResponse?.data?.isEmpty != "1" && grossWeight)) {
            setVinResponse("We are unable to verify the VIN that you entered. Please try again. If you continue to run into the same error, please call 800-535-2873 to proceed with your request.")
            requestTypeContext.setVinLoad(false)
            return;
        }

        var vehicle = newVehicleContext.newVehicle
        vehicle.componentTracker = "VehicleInfo"
        vehicle.vehicleVIN = vinResponse.data?.Vin
        vehicle.vehicleYear = vinResponse.data?.Year
        vehicle.vehicleMake = vinResponse.data?.Make
        vehicle.vehicleModel = vinResponse.data?.Model
        vehicle.vehicleBody = vinResponse.data?.Body
        newVehicleContext.setNewVehicle({ ...newVehicleContext.newVehicle, ...vehicle })

        // Set the vehicle class with new vehicle under vehicles --> vehiclesOnPolicy --> newVehicles
        var vehicleClassCopy = requestTypeContext[endorsementClassStr]
        vehicleClassCopy.vehicles.vehiclesOnPolicy.newVehicles.push(vehicle)
        requestTypeContext[endorsementSetClassStr]({ ...vehicleClassCopy })

        requestTypeContext.setVinLoad(false)
    }

    // Verifies that the vin entered was not entered in the last three days or was already closed
    const checkRecentAddition = (vin) => {
        if (vinList.length > 0 && vinList?.includes(vin)) {
            return true;
        }
        
        return false;
    }

    // Verifies that the vin entered doesn't already exist on policy
    const checkVinExists = (vin) => {
        var vehicles = requestTypeContext[endorsementClassStr].vehicles.vehiclesOnPolicy.storedVehicles
        return vehicles.some(vehicle => vehicle.VIN.toLowerCase() == vin.toLowerCase());
    }

    // Special character check
    const checkSpecialCharacters = (vin) => {
        // Regular expression to check for any character that is not a letter (A-Z) or number (0-9)
        const regex = /[^A-Za-z0-9]/;
        return regex.test(vin);
    }

    // Auto capitalizes input for vin
    const autoCapitalize = (e) => {
        const start = e.target.selectionStart;
        const end = e.target.selectionEnd;
        const upper = e.target.value?.toUpperCase();
        e.target.value = upper;
        e.target.setSelectionRange(start, end);
    }
    // Verifies the VIN input does not exceed above 25 characters
    const checkCharacterLimit = (vin) => {
        return (vin?.length > 25)
    }

    return (
        <>
            {/* Vin Input */}
            {!requestTypeContext.vinLoad &&
                <div className='col-xl-12 justify-content-center' style={{ margin: "0 0.5rem", padding: "0 0.75rem" }}>
                    <div className="row form-group form-group-sm align-items-center my-3">
                        <div className="col-12 col-md-4 text-primary fw-bold mb-2 mb-md-0 fs-6">
                            VIN*
                        </div>
                        <div className="col-12 col-md-8 col-sm-8">
                            <div className="input-group">
                                <input
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    placeholder="Enter your VIN..."
                                    onInput={(e) => { autoCapitalize(e) }}
                                    style={{ fontSize: "15px" }}
                                    ref={vinRef}
                                />
                                <span className="input-group-btn">
                                    <input
                                        type="button"
                                        className="btn btn-default"
                                        value="SUBMIT"
                                        onClick={() => checkVin()}
                                        style={{ position: 'static', fontSize: "15px" }}
                                    />
                                </span>
                            </div>
                        </div>
                        {vinResponse != "" &&
                            <p className='text-danger text-center fw-bold fs-6 p-2'>
                                {vinResponse}
                            </p>
                        }
                    </div>
                </div>
            }

            {/* Spinner for retrieving vehicle info from vin */}
            {requestTypeContext.vinLoad &&
                <div className="text-center">
                    <Spinner animation="border" />
                </div>
            }
        </>
    )
}

export default BodyVIN